import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import "../../assets/styles/local/AddPurchasingOrder.css";
import "../../assets/styles/local/ConfirmPurchasingOrder.css";
import Header from "../../layouts/Header";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import {
  GetPOList,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { Image } from "react-bootstrap";
import "../../assets/styles/local/PurchaseOrder.css";
import Package from "../../assets/icons/package.svg";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
const ViewPurchaseOrderWithQuotes = () => {
  const dispatch = useDispatch();
  const { purchaseOrderID } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { supplierid, suppliername, projectname, quoteId, totalExclusive } = location.state;
  const [totalExclusiveBtw, setTotalExclusiveBtw] = useState("");
  const [poList, setPOList] = useState([]);
  const fetchPoList = useSelector((state) => state.user.PoList);

  useEffect(() => {
    dispatch(GetPOList(quoteId));
  }, []);


  useEffect(() => {
    if (fetchPoList.status === true) {
      setPOList(fetchPoList.data);
      setTotalExclusiveBtw(fetchPoList?.data[0]?.totalOrder);
    }
  }, [fetchPoList]);

  return (
    <>
      <div className="container-fluid main-wrapper mb-4">

        <div className="containerBox">
          <div className="stock-heading-box">
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}>
              Stock
            </div>
            <div className="confirm-box-title2">
              <div className="title2"> Purchasing Orders From Quote</div>
              <div className="order-id">ID {purchaseOrderID}</div>
            </div>
          </div>
          <Header />
        </div>

        <div className="d-flex align-items-center justify-content-end">
          <button
            type="button"
            className="btn addParchCancel me-4"
            onClick={() => {
              history.goBack();
            }}>
            Cancel
          </button>
          <button
            type="button"
            className="btn addParchAdd add-btn-disable"
            disabled>
            Add
          </button>
        </div>
        <div className="PurchScrollWidth">
          <div className="supplierDiv ms-4 me-5 mt-5 ps-4 py-3">
            <table className="table table-borderless">
              <thead>
                <tr className="">
                  <th className="col purchSupplier ps-">Supplier</th>
                  <th className="col pt-1 ps-5">
                    <div className="asc_CustomSelect pt-2">{suppliername}</div>
                  </th>
                  <th className=""></th>
                  <th className="col purshProject ps-">Project</th>
                  <th className="col pt-1 ps-5">
                    <div className="asc_CustomSelect pt-2">{projectname}</div>
                  </th>
                  <th className="col"></th>
                  <th className="col"></th>
                </tr>
              </thead>
            </table>
          </div>

          <div className="supplierDiv px-4 mt-3 ms-4 me-5 py-3">
            <table className="table table-borderless m-0">
              <thead>
                <tr className="purchSupplierCode ps-">
                  <th className="col pb-4 ps-5"></th>
                  <th className="col pb-4 ps-5">Supplier Code</th>
                  <th className="col-4 pb-4 ps-5">Product Description</th>
                  <th className="col pb-4 ps-0">Color</th>
                  <th className="col pb-4 ">Qty</th>
                  <th className="col pb-4 ps-5">Unit Price</th>
                  <th className="col-2 pb-4 purchTotal ps-4">Total</th>
                </tr>
              </thead>

              {poList.map((item, index) => {
                return (
                  <tbody className="horizontalBorderTop" key={index}>
                    <tr className="text-center">
                      <td className="title-hover">
                        <div className="items-desc-column6">
                          <div className="desc-image-wrp6 desc-image6 ">
                            {item.coverimage ? (
                              <>
                                <div
                                  className={`product-list-image-default6 ${item.image.length === 0 ? "hover-hide6" : ""
                                    }`}>
                                  <img
                                    src={item.coverimage}
                                    alt=""
                                    className="cover-image6"
                                  />
                                  {item.image && item.image.length > 0 && (
                                    <div className="image-row6">
                                      {item.image
                                        .slice(0, 3)
                                        .map((val, index) => (
                                          <img
                                            key={index}
                                            src={val}
                                            alt={`Images ${index + 1}`}
                                          />
                                        ))}
                                    </div>
                                  )}
                                </div>
                                {item.image && item.image.length > 0 && (
                                  <span className="desc-image-plus6">
                                    <Image
                                      height={10}
                                      width={10}
                                      src={plusBorderWhite}
                                    />
                                  </span>
                                )}
                              </>
                            ) : (
                              <div className="product-list-default6">
                                <img
                                  src={Package}
                                  alt=""
                                  className="default-img6"
                                />
                                <div className="product-image-title">Picture</div>
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="col-4 text-start ps-5 py-4">
                        {item.suppliercode}
                      </td>
                      <td className="documntName text-start ps-5 py-4">
                        {item.productname}
                      </td>
                      <td className="documntName py-4">
                        {/* <ColorTag tagList={item.productcolor}></ColorTag> */}
                        {/* <ColorTag tagList={[ item.productcolor ]}></ColorTag> */}
                        <div
                          className="asc_color_code"
                          style={{
                            backgroundColor: `${item.productcolor}`,
                          }}></div>
                      </td>
                      <td className="documntName py-4">
                        {item?.orderproductqty ? item?.orderproductqty : ""}
                      </td>
                      <td className="documntName ps-5 py-4">
                        {europeanFormatWithSymbol(item.productcost)}
                      </td>
                      <td className="py-4 ps-5">
                        {europeanFormatWithSymbol(
                          item.productcost * item?.orderproductqty
                        )}
                      </td>
                    </tr>
                  </tbody>
                );
              })}
            </table>

            <div className="horizontalLine"></div>

            <table className="table table-borderless ms-4">
              <thead>
                <tr className="ps-">
                  <th className="col-7"></th>
                  <th className="col-3 purchTotal2 text-center py-4 ps-5">
                    TOTAL
                  </th>
                  <th className="col purchTotal2 py-4 ps-0">
                    {/* {europeanFormatWithSymbol(
                    fetchPurchasingOrder.reduce(
                      (n, { totalExclusiveBtw }) => n + totalExclusiveBtw,
                      0
                    )
                  )} */}
                    {/* {europeanFormatWithSymbol(totalExclusiveBtw)} */}
                    {/* € &nbsp;{totalExclusiveBtw} */}
                    {`€ ${totalExclusive}`}
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPurchaseOrderWithQuotes;
